import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  setPageIndex,
  setPageSize,
  GetMaterialTransactionsPaged,
} from './MaterialTransactionsSlice';

// إنشاء الـ Listener Middleware
export const materialTransactionsListener = createListenerMiddleware();

// دالة لمعالجة تغيير الصفحة
const handlePageIndexChange = (action: any, { dispatch, getState }: any) => {
  console.log("kh");
  
  const { pageSize } = (getState() as any).MaterialTransactions;
  dispatch(GetMaterialTransactionsPaged({ pageIndex: action.payload, pageSize }));
};

// دالة لمعالجة تغيير حجم الصفحة
const handlePageSizeChange = (action: any, { dispatch, getState }: any) => {
  console.log("kh");
  const { pageIndex } = (getState() as any).MaterialTransactions;
  dispatch(GetMaterialTransactionsPaged({ pageIndex, pageSize: action.payload }));
};

// إعداد المستمعات
export const setupMaterialTransactionsListeners = () => {
  materialTransactionsListener.startListening({
    actionCreator: setPageIndex,
    effect: handlePageIndexChange,
  });

  materialTransactionsListener.startListening({
    actionCreator: setPageSize,
    effect: handlePageSizeChange,
  });
};

export default materialTransactionsListener;
